"use strict";

require("node_modules/angular-zxcvbn/dist/angular-zxcvbn.js");

angular.module("passwordStrengthValidator", ["zxcvbn"]);

require("./password-strength-validator.component.js");



//////////////////
// WEBPACK FOOTER
// ./core/password-strength-validator/password-strength-validator.module.js
// module id = 321
// module chunks = 0